/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Money_Art_3_LabelInputs */

const en_services_svc_money_art_3_label = /** @type {(inputs: Services_Svc_Money_Art_3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First message drafted`)
};

const lv_services_svc_money_art_3_label = /** @type {(inputs: Services_Svc_Money_Art_3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pirmā ziņa sagatavota`)
};

/**
* | output |
* | --- |
* | "First message drafted" |
*
* @param {Services_Svc_Money_Art_3_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_money_art_3_label = /** @type {((inputs?: Services_Svc_Money_Art_3_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Money_Art_3_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_money_art_3_label(inputs)
	return en_services_svc_money_art_3_label(inputs)
});